import React, { useCallback, useEffect, useRef, useState } from "react";
import { graphqlRequest } from "../utils/graphqlRequest";
const states = [
  "RECEIVED",
  "UNDER_REVIEW",
  "AWAITING_INFORMATION",
  "QUOTATION_SENT",
  "BOOKING_CONFIRMED",
  "DECLINED",
];
export default function ClientRequestConversation({ bookingId, onUpdated }) {
  const [thread, setThread] = useState(null),
    [status, setStatus] = useState("RECEIVED"),
    [message, setMessage] = useState(""),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false);
  const key = useRef(crypto.randomUUID());
  const load = useCallback(async () => {
    try {
      const d = await graphqlRequest(
        `query($id:String!){adminClientRequestThread(bookingId:$id)}`,
        { id: bookingId },
      );
      setThread(d.adminClientRequestThread);
      setStatus(d.adminClientRequestThread.status);
      setError("");
    } catch (e) {
      setError(e.message);
    }
  }, [bookingId]);
  useEffect(() => {
    load();
  }, [load]);
  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await graphqlRequest(
        `mutation($id:String!,$message:String!,$status:String,$key:String!){respondToClientRequest(bookingId:$id,message:$message,status:$status,requestKey:$key)}`,
        { id: bookingId, message, status, key: key.current },
      );
      setMessage("");
      key.current = crypto.randomUUID();
      await load();
      onUpdated?.();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <section style={{ padding: 12, minWidth: 280, maxWidth: 500 }}>
      <h3>Client request conversation</h3>
      {error && (
        <p role="alert" style={{ color: "#b91c1c" }}>
          {error}
        </p>
      )}
      <button onClick={load} disabled={busy}>
        Refresh conversation
      </button>
      <div style={{ maxHeight: 240, overflowY: "auto" }}>
        {thread?.messages.map((m) => (
          <article
            key={m.id}
            style={{ borderBottom: "1px solid #e2e8f0", padding: 8 }}
          >
            <b>{m.author}</b>
            <p style={{ whiteSpace: "pre-wrap" }}>{m.message}</p>
            <small>{new Date(m.createdAt).toLocaleString("en-AU")}</small>
          </article>
        ))}
      </div>
      <form onSubmit={submit}>
        <fieldset disabled={busy}>
          <label>
            Status
            <select
              aria-label="Request status"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                key.current = crypto.randomUUID();
              }}
            >
              {states.map((s) => (
                <option key={s} value={s}>
                  {s.replaceAll("_", " ")}
                </option>
              ))}
            </select>
          </label>
          <label style={{ display: "block" }}>
            Message to client
            <textarea
              required
              maxLength={4000}
              value={message}
              style={{ width: "100%" }}
              onChange={(e) => {
                setMessage(e.target.value);
                key.current = crypto.randomUUID();
              }}
            />
          </label>
          <button disabled={busy || !message.trim()}>Send update</button>
        </fieldset>
      </form>
    </section>
  );
}
